import { render, staticRenderFns } from "./SettingsTabLoader.vue?vue&type=template&id=9f0bdcec&"
import script from "./SettingsTabLoader.vue?vue&type=script&lang=js&"
export * from "./SettingsTabLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports